<template>
  <Modal class-name="vertical-center-modal" v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">添加特殊折扣</div>
    <Form :model="formData" :label-width="90"  :rules="formRules" ref="formData">
      <FormItem label="服务费折扣" prop="discount">
        <Input v-model="formData.discount" class="item-width" >
          <span slot="append">%</span>
        </Input>
      </FormItem>
      <FormItem label="使用人" prop="uid">
        <Select
        class="item-width remote" 
        :key="n"
        filterable
        remote
        v-model="formData.uid"
        :remote-method="remoteMethod"
        :loading="searchLoading"
        :placeholder="'输入手机号查询'">  
        <Option v-if="this.list.length === 0" value="" disabled>无匹配数据项</Option>   
        <Option v-for="item in list" :value="item.uid" :key="item.uid">{{item.userPhone}}</Option>
      </Select>
      </FormItem>

    </Form>
    <div slot="footer">
      <div>
        <Button type="text" size="large" @click="close">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading" >
          <span v-if="!loading" >保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>  
    </div>

  </Modal>
</template>

<script type="text/ecmascript-6">
import { getUid,addSpecialRules } from '@/api/managementCenter'

export default {
  props:{
    n:{
      type:Number,
      default:0
    }
  },
  watch:{
    n(val) {
      this.show = true
      this.list = []
      this.userName = ''
      this.userPhone = ''
      this.searchLoading = false,
      this.$refs['formData'].resetFields();
    }
  },
  data() {
    const validatDiscount  = (rule, value, callback) => {
      let pattern = /^(1|([1-9]\d{0,1})|100)$/
      if(pattern.test(value)) {
        callback()
      } else{
        callback('输入1-100的整数');
      }
    }
    return {
      loading:false,
      searchLoading:false,
      show: false,
      list:[],
      userPhone:'',
      userName: '',
      formData:{
        discount:'',
        uid:null
      },
      formRules:{
        discount:[{ required: true, validator: validatDiscount, trigger: "blur" }],
        uid:[{ required: true, message:'请选择使用人', trigger: "change" }]
      }
    }
  },
  methods:{
    close(){
      this.show = false
    },
    remoteMethod(query){
      let pattern = /^1\d{10}$/
       if(pattern.test(query)) {
         this.searchLoading= true
         // 调接口
         getUid(query).then( res => {
           this.searchLoading= false
           this.list.splice(0)
           this.list.push(res.data)
           this.userPhone = res.data.userPhone
           this.userName = res.data.userName
         })
       }else {
          this.searchLoading = false
       }
      
    },
    save() {
    // 调接口
     this.$refs[`formData`].validate(bool => {
       if(bool) {
         let data = {
           ruleType: 2,
           discount: this.formData.discount,
           uid: this.formData.uid,
           userPhone: this.userPhone,
           userName : this.userName
         }
         this.loading = true
         addSpecialRules(data).then(res => {
           this.loading = false
            this.$Message.success('添加成功！')
            this.show = false
            this.$emit('refresh')
          }).catch( err => {
            this.loading = false
          })

       }
     })
    
    }

  }
}
</script>